/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkshopProblemScore } from './WorkshopProblemScore';
import {
    WorkshopProblemScoreFromJSON,
    WorkshopProblemScoreFromJSONTyped,
    WorkshopProblemScoreToJSON,
    WorkshopProblemScoreToJSONTyped,
} from './WorkshopProblemScore';
import type { WorkshopProblemRead } from './WorkshopProblemRead';
import {
    WorkshopProblemReadFromJSON,
    WorkshopProblemReadFromJSONTyped,
    WorkshopProblemReadToJSON,
    WorkshopProblemReadToJSONTyped,
} from './WorkshopProblemRead';
import type { WorkshopAttendanceRead } from './WorkshopAttendanceRead';
import {
    WorkshopAttendanceReadFromJSON,
    WorkshopAttendanceReadFromJSONTyped,
    WorkshopAttendanceReadToJSON,
    WorkshopAttendanceReadToJSONTyped,
} from './WorkshopAttendanceRead';

/**
 * Schema for workshop results with all necessary data in one response.
 * 
 * Polled by the results view, so it carries no source code: one aggregated score per
 * (participant, problem). The submissions themselves load per cell from the submissions API.
 * @export
 * @interface WorkshopResults
 */
export interface WorkshopResults {
    /**
     * 
     * @type {Array<WorkshopProblemRead>}
     * @memberof WorkshopResults
     */
    workshop_problems: Array<WorkshopProblemRead>;
    /**
     * 
     * @type {Array<WorkshopAttendanceRead>}
     * @memberof WorkshopResults
     */
    attendance: Array<WorkshopAttendanceRead>;
    /**
     * 
     * @type {Array<WorkshopProblemScore>}
     * @memberof WorkshopResults
     */
    scores: Array<WorkshopProblemScore>;
}

/**
 * Check if a given object implements the WorkshopResults interface.
 */
export function instanceOfWorkshopResults(value: object): value is WorkshopResults {
    if (!('workshop_problems' in value) || value['workshop_problems'] === undefined) return false;
    if (!('attendance' in value) || value['attendance'] === undefined) return false;
    if (!('scores' in value) || value['scores'] === undefined) return false;
    return true;
}

export function WorkshopResultsFromJSON(json: any): WorkshopResults {
    return WorkshopResultsFromJSONTyped(json, false);
}

export function WorkshopResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopResults {
    if (json == null) {
        return json;
    }
    return {
        
        'workshop_problems': ((json['workshop_problems'] as Array<any>).map(WorkshopProblemReadFromJSON)),
        'attendance': ((json['attendance'] as Array<any>).map(WorkshopAttendanceReadFromJSON)),
        'scores': ((json['scores'] as Array<any>).map(WorkshopProblemScoreFromJSON)),
    };
}

export function WorkshopResultsToJSON(json: any): WorkshopResults {
    return WorkshopResultsToJSONTyped(json, false);
}

export function WorkshopResultsToJSONTyped(value?: WorkshopResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshop_problems': ((value['workshop_problems'] as Array<any>).map(WorkshopProblemReadToJSON)),
        'attendance': ((value['attendance'] as Array<any>).map(WorkshopAttendanceReadToJSON)),
        'scores': ((value['scores'] as Array<any>).map(WorkshopProblemScoreToJSON)),
    };
}

